import { render, staticRenderFns } from "./PeriodIdPicker.vue?vue&type=template&id=438c4858&"
import script from "./PeriodIdPicker.vue?vue&type=script&lang=js&"
export * from "./PeriodIdPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("Q:\\Projects\\marketingdatabase-git\\MarketingDb.Web.Zeiss\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('438c4858')) {
      api.createRecord('438c4858', component.options)
    } else {
      api.reload('438c4858', component.options)
    }
    module.hot.accept("./PeriodIdPicker.vue?vue&type=template&id=438c4858&", function () {
      api.rerender('438c4858', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/JourneyBuilder/Components/Charts/SankeyV2/PeriodIdPicker.vue"
export default component.exports